/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";
export const AuditoriaSCH = (perPage)=> {
  let filtro = new Filtro();
  filtro.perPage = perPage;
  filtro.fields = ['acao', 'dt_fitragem', 'dt_log','hr_log','nome','rotina', 'funcionario_id', 'rotina_id'];
  return filtro
};
